import { useIntl } from 'react-intl'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { Typography } from '@mui/material'
import { Button } from '../../../../components/buttons'

interface Props {
  timerRecordOnclick: () => void
}

const TimerRecordCheckButton = ({ timerRecordOnclick }: Props) => {
  const intl = useIntl()

  return (
    <Button
      colorPattern="monotone"
      onClick={timerRecordOnclick}
      sx={{
        margin: '0 5px 0 15px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        minWidth: 'fit-content',
      }}
      variant="outlined"
    >
      <AccessTimeIcon sx={{ height: '16px', width: '16px' }} />
      <Typography>
        {intl.formatMessage({ id: 'workReport.timer.record.open.button' })}
      </Typography>
    </Button>
  )
}

export default TimerRecordCheckButton
